import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Home } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const SOURCE = { profile: "You picked this.", bookings: "Based on where you book most.", address: "Closest to your saved address." };

export const HomeCenterPicker = () => {
  const qc = useQueryClient();
  const { data: opts = [] } = useQuery({ queryKey: ["home-center-options"], queryFn: () => api.get("/home-center/options").then((r) => r.data) });
  const { data: home } = useQuery({ queryKey: ["my-home-center"], queryFn: () => api.get("/me/home-center").then((r) => r.data) });
  const save = async (location_id) => {
    try {
      const { data } = await api.put("/me/home-center", { location_id });
      qc.setQueryData(["my-home-center"], data);
      toast.success("Home center updated");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <section className="eyw-card p-8 mb-8" data-testid="profile-home-center">
      <h2 className="font-serif text-2xl text-[#1A242B] mb-2 flex items-center gap-2"><Home size={20} /> Home center</h2>
      <p className="text-sm text-[#4A5D6B] mb-4">Offerings at your home center show first when you browse.</p>
      <select value={home?.picked || ""} onChange={(e) => save(e.target.value)} className="eyw-input w-full sm:w-96" data-testid="home-center-select">
        <option value="">Choose for me</option>
        {opts.map((o) => <option key={o.id} value={o.id}>{o.name}{o.city ? ` — ${o.city}` : ""}</option>)}
      </select>
      <p className="text-xs text-[#5C8A72] mt-2" data-testid="home-center-current">
        {home?.location_id ? `Your home center: ${home.name}. ${SOURCE[home.source] || ""}` : "No home center yet — pick one, or add your address above."}
      </p>
    </section>
  );
};
